module.exports = __webpack_public_path__ + "53c23b2d029cc72b99870bd59ff4ca36.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-6.png
// module id = 2403
// module chunks = 0